<template lang="pug">
  div
    Header
    router-view
</template>

<script>
export default {
  components: {
    Header: () => import('../../components/Header')
  }
}
</script>
